import React, { useState } from "react";
import { Field } from "formik";
import { MDBInputGroup } from "mdbreact";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

export const InputText = (props: {
  name: string;
  placeholder: string;
  className?: string;
  label?: string;
}) => (
  <div className="form-group">
    <Field id={props.name} name={props.name}>
      {(f: {
        field: { name: any; value: any; onChange?: any; onBlur?: any }; // { name, value, onChange, onBlur }
        form: { touched: boolean; errors: any }; // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
        meta: any;
      }) => (
        <input
          type="text"
          {...f.field}
          className="form-control"
          placeholder={props.placeholder}
        />
      )}
    </Field>
  </div>
);

export const InputPassword = (props: {
  name: string;
  placeholder: string;
  className?: string;
  label?: string;
}) => {
  const [show, setshow] = useState(true);
  return (
    <Field id={props.name} name={props.name}>
      {(f: {
        field: { name: any; value: any; onChange?: any; onBlur?: any }; // { name, value, onChange, onBlur }
        form: { touched: boolean; errors: any }; // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
        meta: any;
      }) => (
        <div
          className={`input-group password ${
            props.className ? props.className : ""
          }`}
        >
          <input
            type={show ? "password" : "text"}
            {...f.field}
            placeholder={props.placeholder}
            className="form-control"
          />
          <div
            className="input-group-append"
            onClick={() => {
              setshow(!show);
            }}
          >
            <span className="input-group-text" id="basic-addon">
              {show ? (
                <FontAwesomeIcon icon={faEye} />
              ) : (
                <FontAwesomeIcon icon={faEyeSlash} />
              )}
            </span>
          </div>
        </div>
      )}
    </Field>
  );
};
